// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AccountSettingsView_avatar__1H11F","account":"AccountSettingsView_account__3_qoI"};